import { BooleanInput, Create, NumberInput, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { levelOptions, typeOptions } from './constants';
import HolidayTemplateDateInputs from './HolidayTemplateDateInputs';
import { transformHolidayTemplate, validateHolidayTemplate } from './holidayTemplateForm';

const HolidayTemplatesCreate = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Create
      transform={transformHolidayTemplate}
      mutationOptions={{
        onSuccess: () => {
          notify('Created');
          navigate(-1);
        }
      }}
    >
      <SimpleForm validate={validateHolidayTemplate}>
        <TextInput source="country" label="Country (2-char ISO)" inputProps={{ maxLength: 2 }} isRequired />
        <TextInput source="name" label="Name" isRequired />
        <SelectInput source="type" label="Type" choices={typeOptions} isRequired />
        <SelectInput source="level" label="Level" choices={levelOptions} isRequired />
        {/* Drives whether Start/End collect a time of day. */}
        <BooleanInput source="allDay" label="All Day" defaultValue={true} helperText="On: a whole calendar day. Off: an event with a start and end time." />
        <HolidayTemplateDateInputs />
        <BooleanInput source="paid" label="Paid" defaultValue={true} />
        <BooleanInput source="repeatAnnually" label="Repeat Annually" defaultValue={true} />
        <NumberInput source="legacyId" label="Legacy ID" />
      </SimpleForm>
    </Create>
  );
};

export default HolidayTemplatesCreate;
